// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"screen-reader-only_srOnly__9ETId"};